<div class="top-section">
    <h6 class="heading mb-0">{{ ss.texts()['calendarEvent_titleTopBar'] }}</h6>
    <div class="flex items-center gap-6">
        <app-svg name="more" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button"
            *ngIf="data.mode === 'edit'" [color]="ss.theme().color12"></app-svg>
        <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu ri-w-350px">
            <button mat-menu-item class="text-14-400 color-8" (click)="openCalendarAccountForm()">
                <app-svg name="edit" [color]="ss.theme().color35" class="ri-me-3"></app-svg>
                <span class="w-full">{{ ss.texts()['calendarAccount_title'] }}</span>
            </button>
        </mat-menu>

        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
    </div>
</div>
<div class="calendar-event-form ri-p-4">
    <form [formGroup]="calendarEventForm" #cEventForm="ngForm" class="flex flex-col gap-8">
        <div class="flex justify-between items-center">
            <app-input-text [control]="getFc('title')" name="meCalendarEventTitle"
                [placeholder]="ss.texts()['common_titlePlaceholder']" [readonly]="true"
                (click)="openAlert()"></app-input-text>
            <app-svg name="calendarIntegration" [color]="ss.theme().color7"
                style="height: 24px; width: 24px;"></app-svg>
        </div>

        <div class="flex items-start w-full" (click)="openAlert()" role="button" *ngIf="getdec('description')">
            <app-svg name="description" [color]="ss.theme().color35" class="ri-pe-4"></app-svg>

            <!-- Option 1: Using Quill View Component (Read-only) -->
            <quill-view [content]="getdec('description')" theme="snow" class="me-input-textarea w-full">
            </quill-view>
        </div>

        <app-input-date-period name="meCalendarEventDateRange" [startControl]="getFc('startAt')"
            [endControl]="getFc('endAt')" [repeatControl]="getFc('repeat')" [readonly]="true" (click)="openAlert()"
            [dueDate]="dueDate()" [selectedDateString]="this.selectedDate()"></app-input-date-period>

        <app-input-time [control]="getFc('startAt')" [isTzAffected]="getFc('isTzAffected')"
            [isStartTimeSet]="getFc('isStartTimeSet')" [duration]="getFc('duration')" [reminder]="getFc('reminderAt')"
            [readonly]="true" (click)="openAlert()"></app-input-time>
        <app-input-reminder c [control]="getFc('reminderAt')" *ngIf="calendarEventForm.value.isStartTimeSet"
            [readonly]="true" (click)="openAlert()"></app-input-reminder>

        <a class="flex items-start" *ngIf="rawData()?.hangoutLink || rawData()?.onlineMeetingUrl"
            (click)="openMeetLink()" role="button">
            <app-svg [name]="calendarType() === 'google' ? 'googleMeet' : 'teamsMeet'"
                [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 block color-35 mb-0 ri-pb-2">{{ calendarType() === 'google' ?
                    ss.texts()['calendarEvent_googleMeetText'] :
                    ss.texts()['calendarEvent_teamsMeetText'] }}</p>
            </div>
        </a>
        <div class="flex items-start" (click)="openLocation()" *ngIf="eventData().location" role="button">
            <app-svg name="location" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0">{{ eventData().location }}</p>
            </div>
        </div>
        <div class="flex items-start" (click)="openAlert()">
            <app-svg name="calendarIntegration" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ eventData().calendarName }}</p>
                <p class="text-12-400 color-7 mb-0">{{ calendarAccount().email }}</p>
            </div>
        </div>
        <div class="flex items-start" (click)="openAlert()" *ngIf="rawData()?.showAs">
            <app-svg name="briefCase" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 capitalize">{{ rawData().showAs }}</p>
            </div>
        </div>
        <div class="flex items-start ri-pb-5" (click)="openAlert()" *ngIf="rawData()?.sensitivity">
            <app-svg name="lock" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 capitalize">{{ rawData().sensitivity }}</p>
            </div>
        </div>
    </form>
</div>
<div class="bottom-section flex items-center justify-end ri-p-4 ri-bt-2">
    <button type="submit" class="btn-text text-16-500 color-35" (click)="closeDialog()">{{
        ss.texts()['common_close'] }}</button>
</div>